import React from 'react';

export const Step1Aside = () => (
  <div className="h-full flex flex-col">
    <div className="px-8 py-6 bg-[#101733] flex-shrink-0">
      <div className="flex items-center space-x-2 mb-6">
        <a href="/professionals" className="text-[#007DD1]">
          <img src="/img/pure-reg.svg" alt="Logo" />
        </a>
      </div>

      <p className="text-[#007DD1] text-base font-semibold pb-3">Register</p>

      <h2 className="text-[#F3F4F8] text-2xl font-semibold pb-8">
          Register to gain access to our range of lifetime mortgages
      </h2>

      <div className="flex items-start gap-4 pb-6">
        <img src="/img/icons/grid-01-gray.svg" alt="Grid" className="w-6 h-6" />

        <p className="text-[#F3F4F8] text-base font-semibold">
            Access to exclusive marketing resources <br /> <span className="text-[#F3F4F8] text-base font-450 mb-4">
            Our Marketing Toolkit can help you grow your business.</span>
        </p>
      </div>

      <div className="flex items-start gap-4 pb-8">
        <img src="/img/icons/home-smile-gray.svg" alt="Home" className="w-6 h-6" />

        <p className="text-[#F3F4F8] text-base font-semibold">
            Step 1: <br /> <span className="text-[#F3F4F8] text-base font-450 mb-8">
            Let&#39;s get you set up with a secure online portal account.</span>
        </p>
      </div>
    </div>

    <div className="flex-1 overflow-hidden">
      <img
        src="/img/adviser/register/Img.webp"
        alt="Smiling man on the phone reading a letter at his desk"
        fetchPriority="high"
        className="w-full h-full object-cover object-top"
      />
    </div>
  </div>
);
